/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Tooltip, Form, Input, Select, Tag, Spin } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import ModalPersonalData from './components/ModalPersonalData';
import ModalSensitiveData from './components/ModalSensitiveData';
import { useNavigate, useParams } from 'react-router-dom';
import MyTaskService from '../../../services/MyTask.service';
import InfiniteScroll from 'react-infinite-scroll-component';
import IconNoData from '../../../assets/Images/icons/icon-no-data';
import { ROUTER } from '../../../constants/router';

const { Option } = Select;

export default function ActivityList() {
    const [form] = Form.useForm();
    const { t, i18n } = useTranslation();
    let lang = i18n.language;
    let navigate = useNavigate();
    let { tab, dsrTaskId } = useParams();

    const [dataUsageDepartmentList, setDataUsageDepartmentList] = useState([]);
    const [dataCollectDepartmentList, setDataCollectDepartmentList] = useState(
        []
    );

    const [keyWord, setKeyWord] = useState();
    const [dataUsageDepartmenId, setDataUsageDepartmentId] = useState();
    const [dataCollectDepartmentId, setDataCollectDepartmentId] = useState();

    const [activityList, setActivityList] = useState([]);
    const [openPersonalDataModal, setOpenPersonalDataModal] = useState(false);
    const [openSensitiveDataModal, setOpenSensitiveDataModal] = useState(false);
    // const [openStoragePeriod, setOpenStoragePeriod] = useState(false);
    const [personalData, setPersonalData] = useState([]);
    const [sensitiveData, setSensitiveData] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    // const [histories, setHistories] = useState([]);
    const [loading, setLoading] = useState(false);

    const onChange = async (e) => {
        setKeyWord(e.target.value);
        setActivityList([]);
        setTotal(0);
        setPage(1);
    };
    const onDataUsageDepartmentChange = async (value) => {
        setDataUsageDepartmentId(value);
        setActivityList([]);
        setTotal(0);
        setPage(1);
    };
    const onDataCollectDepartmentChange = async (value) => {
        setDataCollectDepartmentId(value);
        setActivityList([]);
        setTotal(0);
        setPage(1);
    };

    const getActivityList = async () => {
        const params = {
            p: page,
            ps: 10,
            keyword: form.getFieldValue('keyWord'),
            dsrTaskId: dsrTaskId,
            dataUsageDepartmentId: form.getFieldValue('dataUsageDepartmentId'), //แผนกที่ใช้ข้อมูล
            dataCollectDepartmentId: form.getFieldValue(
                'dataCollectDepartmentId'
            ), //แผนกที่จัดเก็บข้อมูล
        };
        setLoading(true);
        try {
            // setTimeout(async () => {
            const { data } = await MyTaskService.getActivityList(params);
            if (data?.resultData) {
                const items = data?.resultData;
                const activityLists = activityList.concat(items?.result);
                let activities = [];
                for (let activity of activityLists) {
                    const lawfulgeneral = activity.lawfulBasisList.filter(
                        (item) => item.lawfulBasisGroup === 'general'
                    );
                    const lawfulsensitive = activity.lawfulBasisList.filter(
                        (item) => item.lawfulBasisGroup === 'sensitive'
                    );
                    activities.push({
                        ...activity,
                        lawfulgeneral,
                        lawfulsensitive,
                    });
                }
                setActivityList(activities);
                setPage(page + 1);
                setTotal(items?.total);
                setLoading(false);
            } else {
                setLoading(false);
            }
            // }, 1000);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        getActivityList();
    }, [keyWord, dataUsageDepartmenId, dataCollectDepartmentId]);

    useEffect(() => {
        const getDataUsageDepartments = async () => {
            try {
                // let lang = i18n.language;
                const { data } = await MyTaskService.getDataUsageDepartments(
                    dsrTaskId
                );
                if (data?.resultData) {
                    setDataUsageDepartmentList(data?.resultData);
                }
            } catch (err) {
                console.log(err);
            }
        };
        const getDataCollectDepartments = async () => {
            try {
                // let lang = i18n.language;
                const { data } = await MyTaskService.getDataCollectDepartments(
                    dsrTaskId
                );
                if (data?.resultData) {
                    setDataCollectDepartmentList(data?.resultData);
                }
            } catch (err) {
                console.log(err);
            }
        };
        getActivityList();
        getDataUsageDepartments();
        getDataCollectDepartments();
    }, [lang]);

    const getDataCollectDepartments = (departmentsList) => {
        if (departmentsList?.length > 0) {
            let departments = [];
            departmentsList?.forEach((element) => {
                if (element?.departmentNameEn) {
                    departments.push(
                        lang === 'en'
                            ? ' ' + element?.departmentNameEn
                            : ' ' + element?.departmentNameTh
                    );
                }
            });
            return departments?.length > 0 ? departments.toString() : '-';
        } else {
            return '-';
        }
    };
    const getStorageLocation = (locationList) => {
        if (locationList?.length > 0) {
            let location = [];
            locationList?.forEach((element) => {
                if (element?.nameEn) {
                    location.push(
                        lang === 'en'
                            ? ' ' + element?.nameEn
                            : ' ' + element?.nameTh
                    );
                }
            });
            return location?.length > 0 ? location.toString() : '-';
        } else {
            return '-';
        }
    };
    return (
        <>
            <div className="col-span-1 bg-white h-max rounded-xl p-4 py-4 my-4">
                <div className="text-[16px] font-semibold mb-4">
                    {t('MyTask.RelatedActivities')} ({total || 0})
                </div>

                <Form form={form} layout="vertical">
                    <div className="grid grid-cols-3 gap-4">
                        <div className="col-span-1">
                            <Form.Item className="w-full mb-0'" name="keyWord">
                                <Input
                                    prefix={
                                        <SearchOutlined className="site-form-item-icon" />
                                    }
                                    placeholder={t('MyTask.SearchActivity')}
                                    size="large"
                                    onChange={onChange}
                                    allowClear
                                />
                            </Form.Item>
                        </div>
                        <div className="col-span-1">
                            <Form.Item
                                name="dataUsageDepartmentId"
                                className="w-full mb-0"
                            >
                                <Select
                                    size="large"
                                    onChange={onDataUsageDepartmentChange}
                                    placeholder={t('MyTask.Department')}
                                    allowClear
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.children ?? '')
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                >
                                    {dataUsageDepartmentList?.map((e) => (
                                        <Option
                                            key={e.departmentId}
                                            value={e.departmentId}
                                        >
                                            {lang === 'en'
                                                ? e.departmentNameEn
                                                : e.departmentNameTh}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                        <div className="col-span-1">
                            <Form.Item
                                name="dataCollectDepartmentId"
                                className="w-full mb-0"
                            >
                                <Select
                                    size="large"
                                    onChange={onDataCollectDepartmentChange}
                                    placeholder={t('MyTask.StorageDepartment')}
                                    allowClear
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.children ?? '')
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                >
                                    {dataCollectDepartmentList?.map((e) => (
                                        <Option
                                            key={e?.departmentId}
                                            value={e?.departmentId}
                                        >
                                            {lang === 'en'
                                                ? e.departmentNameEn
                                                : e.departmentNameTh}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                    </div>
                </Form>
                <div
                    className="my-1"
                    style={{ borderBottom: '1px solid #ECECEC' }}
                ></div>
                <Spin spinning={loading}>
                    {activityList.length > 0 ? (
                        <div
                            id="scrollableDiv"
                            className="overflow-y-scroll  h-[58vh] p-2 pb-12"
                        >
                            <InfiniteScroll
                                dataLength={activityList.length}
                                next={getActivityList}
                                hasMore={activityList.length < total}
                                scrollableTarget="scrollableDiv"
                                style={{ paddingTop: 5 }}
                                // loader={<h4>Loading...</h4>}
                            >
                                {activityList?.map((e) => (
                                    <div
                                        key={e?.activityId}
                                        className="bg-[#F3F9FF] rounded-xl p-4 my-4"
                                    >
                                        <button
                                            type="button"
                                            className="text-sm text-[#7B67FB] font-semibold cursor-pointer hover:text-[#1890FF]"
                                            onClick={() =>
                                                navigate(
                                                    `${ROUTER.DS_360.MY_TASK}/${tab}/${dsrTaskId}/ropa/${e?.activityId}/view`
                                                )
                                            }
                                        >
                                            {t('Activity Name')} :{' '}
                                            {e.activityName || '-'}
                                        </button>
                                        <div
                                            className="my-1"
                                            style={{
                                                borderBottom:
                                                    '1px solid #ECECEC',
                                            }}
                                        ></div>
                                        <div className="grid grid-cols-9 gap-2 mt-2 space-x-2 ">
                                            <div className="text-sm font-semibold col-span-3">
                                                {t('MyTask.LawfulBasisGeneral')}{' '}
                                                :
                                            </div>
                                            <div className="col-span-6">
                                                {e.lawfulgeneral.map((item) => (
                                                    <p className="text-sm m-0">
                                                        {lang === 'en'
                                                            ? item?.lawfulBasisNameEn ||
                                                              '-'
                                                            : item?.lawfulBasisNameTh ||
                                                              '-'}
                                                    </p>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-9 mt-2 space-x-2">
                                            <div className="text-sm font-semibold col-span-3">
                                                {t(
                                                    'MyTask.LawfulBasisSensitive'
                                                )}{' '}
                                                :
                                            </div>
                                            <div className="text-sm col-span-6">
                                                {e.lawfulsensitive.map(
                                                    (item) => (
                                                        <p className="text-sm m-0">
                                                            {lang === 'en'
                                                                ? item?.lawfulBasisNameEn ||
                                                                  '-'
                                                                : item?.lawfulBasisNameTh ||
                                                                  '-'}
                                                        </p>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-9 mt-2 space-x-2">
                                            <div className="text-sm font-semibold col-span-3">
                                                {t('MyTask.Department')} :
                                            </div>
                                            <div className="text-sm col-span-6">
                                                {lang === 'en'
                                                    ? e?.dataUsageDepartmentNameEn
                                                    : e?.dataUsageDepartmentNameTh ||
                                                      '-'}
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-9 mt-2 space-x-2">
                                            <div className="text-sm font-semibold col-span-3">
                                                {t(
                                                    'MyTask.DepartmentResponsiable'
                                                )}{' '}
                                                :
                                            </div>
                                            <div className="text-sm col-span-6">
                                                {getDataCollectDepartments(
                                                    e?.dataCollectDepartments
                                                )}
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-9 mt-2 space-x-2">
                                            <div className="text-sm font-semibold col-span-3">
                                                {t('MyTask.StorageLocation')} :
                                            </div>
                                            <div className="text-sm col-span-6">
                                                {getStorageLocation(
                                                    e?.storageLocation
                                                )}
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-9 mt-2 space-x-2">
                                            <div className="text-sm font-semibold col-span-3">
                                                {t('MyTask.PersonalData')} :
                                            </div>
                                            <div className="text-sm col-span-6">
                                                {e?.personalData?.length > 0 ? (
                                                    e?.personalData?.map(
                                                        (item, index) => {
                                                            if (index < 5) {
                                                                return (
                                                                    <Tag
                                                                        className="mb-1"
                                                                        style={{
                                                                            backgroundColor:
                                                                                '#DFF3FC',
                                                                            color: '#1890FF',
                                                                            border: '0px',
                                                                            borderRadius:
                                                                                '17px',
                                                                        }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                overflow:
                                                                                    'hidden',
                                                                                whiteSpace:
                                                                                    'nowrap',
                                                                                textOverflow:
                                                                                    'ellipsis',
                                                                                // maxWidth: '250px',
                                                                            }}
                                                                        >
                                                                            <Tooltip
                                                                                className="cursor-pointer"
                                                                                placement="topLeft"
                                                                                title={
                                                                                    <>
                                                                                        {lang ===
                                                                                        'en'
                                                                                            ? item?.personalDataEn
                                                                                            : item?.personalDataTh ||
                                                                                              '-'}
                                                                                    </>
                                                                                }
                                                                            >
                                                                                {lang ===
                                                                                'en'
                                                                                    ? item?.personalDataEn
                                                                                    : item?.personalDataTh ||
                                                                                      '-'}
                                                                            </Tooltip>
                                                                        </div>
                                                                    </Tag>
                                                                );
                                                            }
                                                        }
                                                    )
                                                ) : (
                                                    <div className="text-gray-600">
                                                        -
                                                    </div>
                                                )}
                                                {e?.personalData?.length >
                                                    5 && (
                                                    <Tag
                                                        className="cursor-pointer"
                                                        style={{
                                                            backgroundColor:
                                                                '#B2B2B2',
                                                            color: '#FFFFFF',
                                                            border: '0px',
                                                            borderRadius:
                                                                '17px',
                                                            overflow: 'hidden',
                                                            whiteSpace:
                                                                'nowrap',
                                                            textOverflow:
                                                                'ellipsis',
                                                            // maxWidth: '250px',
                                                        }}
                                                        onClick={() => {
                                                            setPersonalData(
                                                                e?.personalData
                                                            );
                                                            setOpenPersonalDataModal(
                                                                true
                                                            );
                                                        }}
                                                    >
                                                        +
                                                        {e?.personalData
                                                            ?.length - 4}
                                                    </Tag>
                                                )}
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-9 mt-2 space-x-2">
                                            <div className="text-sm font-semibold col-span-3">
                                                {t('MyTask.SensitiveData')} :
                                            </div>
                                            <div className="text-sm col-span-6">
                                                {e?.sensitivePersonalData
                                                    ?.length > 0 ? (
                                                    e?.sensitivePersonalData?.map(
                                                        (item, index) => {
                                                            if (index < 5) {
                                                                return (
                                                                    <Tag
                                                                        className="mb-1"
                                                                        style={{
                                                                            backgroundColor:
                                                                                '#FFF7E6',
                                                                            color: '#FF6E04',
                                                                            border: '0px',
                                                                            borderRadius:
                                                                                '17px',
                                                                        }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                overflow:
                                                                                    'hidden',
                                                                                whiteSpace:
                                                                                    'nowrap',
                                                                                textOverflow:
                                                                                    'ellipsis',
                                                                                // maxWidth: '250px',
                                                                            }}
                                                                        >
                                                                            <Tooltip
                                                                                className="cursor-pointer"
                                                                                placement="topLeft"
                                                                                title={
                                                                                    <>
                                                                                        {lang ===
                                                                                        'en'
                                                                                            ? item?.sensitivePersonalDataEn
                                                                                            : item?.sensitivePersonalDataTh ||
                                                                                              '-'}
                                                                                    </>
                                                                                }
                                                                            >
                                                                                {lang ===
                                                                                'en'
                                                                                    ? item?.sensitivePersonalDataEn
                                                                                    : item?.sensitivePersonalDataTh ||
                                                                                      '-'}
                                                                            </Tooltip>
                                                                        </div>
                                                                    </Tag>
                                                                );
                                                            }
                                                        }
                                                    )
                                                ) : (
                                                    <div className="text-gray-600">
                                                        -
                                                    </div>
                                                )}
                                                {e?.sensitivePersonalData
                                                    ?.length > 5 && (
                                                    <Tag
                                                        className="cursor-pointer"
                                                        style={{
                                                            backgroundColor:
                                                                '#B2B2B2',
                                                            color: '#FFFFFF',
                                                            border: '0px',
                                                            borderRadius:
                                                                '17px',
                                                            overflow: 'hidden',
                                                            whiteSpace:
                                                                'nowrap',
                                                            textOverflow:
                                                                'ellipsis',
                                                            // maxWidth: '250px',
                                                        }}
                                                        onClick={() => {
                                                            setSensitiveData(
                                                                e?.sensitivePersonalData
                                                            );
                                                            setOpenSensitiveDataModal(
                                                                true
                                                            );
                                                        }}
                                                    >
                                                        +
                                                        {e
                                                            ?.sensitivePersonalData
                                                            ?.length - 4}
                                                    </Tag>
                                                )}
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-9 mt-2 space-x-2">
                                            <div className="text-sm font-semibold col-span-3">
                                                {t('MyTask.RelevantConsent')} :
                                            </div>
                                            <div className="text-sm col-span-6">
                                                {e?.consents?.length > 0 ? (
                                                    <>
                                                        {e?.consents?.map(
                                                            (item) => (
                                                                <p className="mb-0">
                                                                    &#8226;{' '}
                                                                    {lang ===
                                                                    'en'
                                                                        ? item?.consentEn
                                                                        : item?.consentTh ||
                                                                          '-'}
                                                                </p>
                                                            )
                                                        )}
                                                    </>
                                                ) : (
                                                    <>-</>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </InfiniteScroll>
                        </div>
                    ) : (
                        <div className="text-center text-sm space-y-2 my-56">
                            <IconNoData />
                            <p className="text-[#65707A] text-[14px]">
                                {t('common.noData')}
                            </p>
                        </div>
                    )}
                </Spin>
            </div>
            <ModalPersonalData
                open={openPersonalDataModal}
                handelClose={() => setOpenPersonalDataModal(false)}
                personalData={personalData}
            />

            <ModalSensitiveData
                open={openSensitiveDataModal}
                handelClose={() => setOpenSensitiveDataModal(false)}
                sensitiveData={sensitiveData}
            />
        </>
    );
}
